import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Header from './components/Header';
import Footer from './components/Footer';
import AboutUs from './pages/AboutUs';
import Cookie from './pages/Cookie';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import AlzheimersDementiaCare from './pages/AlzheimersDementiaCare';
import CompanionshipCare from './pages/CompanionshipCare';
import HospiceCare from './pages/HospiceCare';
import PersonalCare from './pages/PersonalCare';
import PostOperativeCare from './pages/PostOperativeCare';
import RespiteCare from './pages/RespiteCare';
import SpecialtyCare from './pages/SpecialtyCare';
import SpinalCordInjuryCare from './pages/SpinalCordInjuryCare';
import FAQ from './pages/FAQ';
import MeetTheTeam from './pages/MeetTheTeam';
import ReviewsTestimonials from './pages/ReviewsTestimonials';
import PrivacyPolicy from './pages/PrivacyPolicy';
import InvoicePayments from './pages/InvoicePayments';
import ManageInvoices from './pages/ManageInvoices';
import NotFound from './pages/NotFound';
import Careers from './pages/Careers';
import HealthcareAssistantJob from './pages/jobs/HealthcareAssistantJob';
import PhysiotherapistJob from './pages/jobs/PhysiotherapistJob';
// import DriverJob from './pages/jobs/DriverJob'; // Driver role temporarily removed
import JobApplicationForm from './pages/jobs/JobApplicationForm';
import AdminDashboard from './pages/admin/AdminDashboard';
import ManageContracts from './pages/admin/ManageContracts';
import ContractSubmissionPage from './pages/ContractSubmissionPage';
import SignAgreement from './pages/SignAgreement';
import PositionDescription from './pages/PositionDescription';

// Routes that should render WITHOUT the bandn marketing header/footer —
// e.g. the AUHCA candidate signing flow + the standalone Position
// Description page that the signed-contract email links to. Both reach
// bandn via an external link and should stay focused on the document
// itself, no nav distractions.
const isStandaloneRoute = (pathname) =>
  pathname.startsWith('/sign/') ||
  pathname.startsWith('/positions/');

const AppShell = () => {
  const location = useLocation();
  const standalone = isStandaloneRoute(location.pathname);
  return (
    <>
      {!standalone && <Header />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/terms-of-service" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<Cookie />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/alzheimers-dementia-care" element={<AlzheimersDementiaCare />} />
        <Route path="/services/companionship-care" element={<CompanionshipCare />} />
        <Route path="/services/hospice-care" element={<HospiceCare />} />
        <Route path="/services/personal-care" element={<PersonalCare />} />
        <Route path="/services/post-operative-care" element={<PostOperativeCare />} />
        <Route path="/services/respite-care" element={<RespiteCare />} />
        <Route path="/services/specialty-care" element={<SpecialtyCare />} />
        <Route path="/services/spinal-cord-injury-care" element={<SpinalCordInjuryCare />} />
        <Route path="/about/faq" element={<FAQ />} />
        <Route path="/about/meet-the-team" element={<MeetTheTeam />} />
        <Route path="/about/reviews-testimonials" element={<ReviewsTestimonials />} />
        <Route path="/invoice/payments" element={<InvoicePayments />} />
        <Route path="/invoice/manage" element={<ManageInvoices />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/jobs/healthcare-assistant" element={<HealthcareAssistantJob />} />
        <Route path="/jobs/healthcare-assistant/apply" element={<JobApplicationForm />} />
        <Route path="/jobs/physiotherapist" element={<PhysiotherapistJob />} />
        <Route path="/jobs/physiotherapist/apply" element={<JobApplicationForm />} />
        {/* Driver role temporarily removed
        <Route path="/jobs/driver" element={<DriverJob />} />
        <Route path="/jobs/driver/apply" element={<JobApplicationForm />} /> */}
        <Route path="/submit-contract" element={<ContractSubmissionPage />} />
        <Route path="/admin/applications" element={<AdminDashboard />} />
        <Route path="/admin/contracts" element={<ManageContracts />} />

        {/* AUHCA candidate signing flow — public, no auth, header/footer
            hidden by isStandaloneRoute() above. */}
        <Route path="/sign/:refId" element={<SignAgreement />} />

        {/* Standalone Position Description (Schedule A) — public,
            linked from the post-signing email and from the AUHCA
            candidate portal. No header/footer per isStandaloneRoute
            above. */}
        <Route path="/positions/personal-care-assistant" element={<PositionDescription />} />

        {/* Catch-all route for 404 pages */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!standalone && <Footer />}
    </>
  );
};

const App = () => (
  <Router>
    <AppShell />
  </Router>
);

export default App;
